var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"link-share",class:( _obj = {}, _obj[_vm.size] = _vm.size, _obj ),attrs:{"href":_vm.shareLink,"target":"simplecast"}},[(_vm.size === 'size-mini')?[_vm._v("\n    Share\n  ")]:[_vm._v("\n    Share Link\n    "),_c('IconLink')]],2)
var _obj;}
var staticRenderFns = []

export { render, staticRenderFns }